import ProfileLoader from "../../../../../../../components/ABOProfile/ProfileLoader/ProfileLoader";
import IdleCustomer from "../../../../../../../components/CustomerProfile/IdleCustomer/IdleCustomer";
import { CustomersResponse } from "../../../../../../../services/Customer/CustomerList/customerListAPI.types";

type Props = {
  customerData?: CustomersResponse;
  isFetching: boolean;
  profileABO: string;
};

const IdleCustomerView = (props: Props) => {
  const { isFetching, customerData, profileABO } = props;

  if (isFetching === false && customerData) {
    const { CustomerList } = customerData;
    const [profileAff, profileAbo] = profileABO.split("-");
    const customerDetail = CustomerList?.find(({ AffAbo }) => {
      if (!AffAbo) return false;
      const [customerAff, customerAbo] = AffAbo.split("-");
      return Number(customerAff) === Number(profileAff) && customerAbo === profileAbo;
    });

    return <IdleCustomer customerDetail={customerDetail} dayCount={30} />;
  }

  return <ProfileLoader row={1} card={true} isFetching={isFetching} />;
};

export default IdleCustomerView;
